export default "__VITE_ASSET__68188e89__"